import React, {
 useState, useEffect, useContext, useRef, 
} from 'react';
import {
 Col, Container, Row, Form, 
} from 'react-bootstrap';
import { Button, ButtonGroup } from '@/shared/components/Button';
import toast from 'react-hot-toast';
import { FaExclamationCircle, FaFilter } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import Pagination from 'react-bootstrap/Pagination';

import MealCard from './MealCard';
import { Mealcontext } from '../../../../context/MealContext';
import { BookingContext } from '../../../../context/BookingContext';
import { ThemeContext } from '../../../../context/ThemeContext';
import ProgressBar from '../../Loader';
import { AuthContext } from '../../../../context/AuthContext';
import { SideBarRefreshContext } from '../../../../context/SideBarRefreshContext';

const Search = () => {
  const { refresh, setRefresh } = useContext(Mealcontext);
  const { currentTheme } = useContext(ThemeContext);
  const { tripDataFlag, setTripDataFlag } = useContext(BookingContext);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [mealsdata, setMealsData] = useState([]);
  const [filteredMealsData, setFilteredMealsData] = useState([]);
  const [isLoading, setIsloading] = useState(true);
  const { apiGlobal, countryid } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const history = useHistory();
  const isMounted = useRef(true);

  const CACHE_TTL = 60 * 1000; // 1 minute TTL (in milliseconds)

// Fetch Meals Data with Cache API and TTL
const fetchMealsData = async (forceRefresh = false) => {
  setIsloading(true);

  try {
    const cacheName = 'mealsCache'; // Define a cache name
    const cache = await caches.open(cacheName);

    const currentTime = new Date().getTime(); // Current timestamp in milliseconds

    if (!forceRefresh) {
      // If we are not forcing a refresh, check cache
      const cachedResponse = await cache.match(`${apiGlobal}meal_data_new.php`);

      if (cachedResponse) {
        const cachedData = await cachedResponse.json();
        const { cachedAt } = cachedData;

        // If cached data is still valid based on TTL, use it
        if (currentTime - cachedAt < CACHE_TTL) {
          console.log('Using cached data');
          setMealsData(cachedData.data);
          setFilteredMealsData(cachedData.data);
          setIsloading(false);
          return; // Return early if cache is valid
        }

        console.log('Cache expired, fetching new data');
        // If cached data is expired, delete it from the cache
        await cache.delete(`${apiGlobal}meal_data_new.php`);
      }
    }
     const formData = new FormData();
     formData.append('country_id', countryid);
    // Fetch new data from API (this will run even if cache is valid if `forceRefresh` is true)
    const response = await fetch(`${apiGlobal}meal_data_new.php`, {
      method: 'POST',
      body: formData,

    });
    const mealsResponse = await response.json();

    if (mealsResponse && Array.isArray(mealsResponse.data)) {
      console.log('Loaded data from API');
      if (isMounted.current) {
        setMealsData(mealsResponse.data);
        setFilteredMealsData(mealsResponse.data);

        // Add TTL information to the data before caching
        const dataWithTTL = {
          data: mealsResponse.data,
          cachedAt: currentTime, // Store the time when the data was cached
        };

        // Cache the new response for future use
        await cache.put(
          `${apiGlobal}meal_data_new.php`,
          new Response(JSON.stringify(dataWithTTL)),
        );
      }
    } else {
      console.log('No data found');
      if (isMounted.current) {
        setMealsData([]);
        setFilteredMealsData([]);
      }
    }
  } catch (error) {
    console.error('Error loading meals', error);
  } finally {
    setIsloading(false);
  }
};

useEffect(() => {
  isMounted.current = true;
  fetchMealsData(); // Initial data fetch

  // Set interval to refresh data every 1 minute
  const intervalId = setInterval(fetchMealsData, CACHE_TTL); // Adjusted to TTL

  // Clear the interval on component unmount
  return () => {
    isMounted.current = false;
    clearInterval(intervalId); // Clean up the interval
  };
}, [refresh, sideBarRefresh?.adminMealRefresh]); // Will re-fetch when refresh context changes

// Trigger the fetchMealsData with a forced refresh when refresh state changes
const handleRefreshTrigger = () => {
  fetchMealsData(true); // Pass true to force fetching fresh data
};


  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      const filteredData = mealsdata.filter(meal => meal.name.toLowerCase().includes(query.toLowerCase()));
      setFilteredMealsData(filteredData); 
    } else {
      setFilteredMealsData(mealsdata); 
    }
  };

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = filteredMealsData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredMealsData.length / itemsPerPage);

  const pageNumbers = [];
  const maxVisiblePages = 3;
  const startPage = Math.max(1, currentPage - 1);
  const endPage = Math.min(totalPages, currentPage + 1);

  for (let i = startPage; i <= endPage; i += 1) {
    pageNumbers.push(i);
  }

  if (startPage > 1) {
    pageNumbers.unshift('...');
  }

  if (endPage < totalPages) {
    pageNumbers.push('...');
  }

  if (pageNumbers[pageNumbers.length - 1] !== totalPages) {
    pageNumbers.push(totalPages);
  }

  const handleCancelAddMeal = () => {
    if (tripDataFlag.addMealINBooking) {
      setTripDataFlag(prevState => ({
        ...prevState,
        tripID: '',
        name: '',
        addMealINBooking: false,
      }));
      toast.success('Add Meal Cancel');
    }

    history.push('/admin/booking');
  };
    // use Effect to add keyframes for the pulse animation
    useEffect(() => {
      // Add keyframes via JavaScript when component mounts
      const style = document.createElement('style');
      style.innerHTML = `
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }, []);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', height: '100vh' }}>
        <ProgressBar />
      </div>
    );
  }

  return (
    <Container>
      <Row>
        <Col md={12} />
      </Row>

      <Row>
        <div className="col-md-4 mb-4 d-flex align-items-center">
          <Form.Control
            type="text"
            placeholder="Search by Meal Name..."
            value={searchQuery}
            onChange={handleSearch}
            className="flex-grow-1"
            style={{
              backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
              color: currentTheme === 'Dark' ? 'white' : 'black',
            }}
          />
          <ButtonGroup icons dir="ltr" className="mt-2">
            <Button
              variant="outline-secondary"
              className="ms-3"
              title="Refresh"
              size="sm"
              onClick={() => handleRefreshTrigger()}
            >
              <span className="lnr lnr-sync" />
            </Button>
          </ButtonGroup>
          <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
            {tripDataFlag.addMealINBooking && (
            <Button variant="danger" title="Cancel Add Meal" size="sm" onClick={handleCancelAddMeal}>
              Cancel Add Meal
            </Button>
             )}
          </ButtonGroup>

          {/* <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
            <Button variant="outline-info" title="Filter">
              <FaFilter />
            </Button>
          </ButtonGroup> */}
        </div>
      </Row>

      <Row>
        <div>
          {filteredMealsData.length === 0 ? (
            <div style={{
            textAlign: 'center',
padding: '50px',
backgroundColor: '#f8d7da',
borderRadius: '8px',
marginTop: '20px',
            color: '#721c24',
fontSize: '16px',
          }}
            >
              <div
                style={{
fontSize: '48px',
marginBottom: '20px',
color: '#e63946',
animation: 'pulse 1.5s infinite ease-in-out',
display: 'inline-block',
}}
              >
                <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
              </div>
              <p>{searchQuery ? 'No results found for your search' : 'No meal available'}</p>
            </div>
          ) : (
            currentItems.map(meal => (
              <div key={meal.id}>
                <MealCard
                  id={meal.id}
                  mealname={meal.name}
                  restaurantname={meal.restaurant_name}
                  description={meal.description}
                  type={meal.meal_type}
                  capacity={meal.capacity}
                  price={meal.price}
                  finalprice={meal.final_price}
                  format={meal.meal_format}
                  image={meal.photo}
                  isVeg={meal.veg_non_veg}
                  mealOffereds={meal.meal_offered}
                  cuisine={meal.cuisines}
                  theme={currentTheme}
                  locations={meal.locations}
                  handleRefreshTrigger={handleRefreshTrigger}
                />
              </div>
            ))
          )}
        </div>
      </Row>
      <div
        style={{
          bottom: '20px',
          right: '20px',
          zIndex: 999,
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        {filteredMealsData.length !== 0 && (
          <Pagination>
            <Pagination.Prev
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {pageNumbers.map((number, index) => (number === '...' ? (
              <Pagination.Ellipsis key={number} />
          ) : (
            <Pagination.Item
              key={number}
              active={number === currentPage}
              onClick={() => setCurrentPage(number)}
            >
              {number}
            </Pagination.Item>
          )))}
            <Pagination.Next
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        )}
        
      </div>
    </Container>
  );
};

export default Search;


 

// import React, {
//   useState, useEffect, useContext, useRef, 
//  } from 'react';
//  import {
//   Col, Container, Row, Form, 
//  } from 'react-bootstrap';
//  import { Button, ButtonGroup } from '@/shared/components/Button';
//  import toast from 'react-hot-toast';
//  import { useHistory } from 'react-router-dom';
//  import Pagination from 'react-bootstrap/Pagination';
//  import { FaFilter } from 'react-icons/fa';
//  import MealCard from './MealCard';
//  import { Mealcontext } from '../../../../context/MealContext';
//  import { BookingContext } from '../../../../context/BookingContext';
//  import { ThemeContext } from '../../../../context/ThemeContext';
 
//  const Search = () => {
//    const { refresh, setRefresh } = useContext(Mealcontext);
//    const { currentTheme } = useContext(ThemeContext);
//    const { tripDataFlag, setTripDataFlag } = useContext(BookingContext);
//    const [searchQuery, setSearchQuery] = useState('');
//    const [mealsData, setMealsData] = useState([]);
//    const [filteredMealsData, setFilteredMealsData] = useState([]);
//    const [loading, setLoading] = useState(false);
//    const [apiError, setApiError] = useState(null); // Renamed `error` to `apiError` to avoid shadowing
 
//    // Pagination state
//    const [currentPage, setCurrentPage] = useState(1);
//    const itemsPerPage = 10;
//    const [totalRecords, setTotalRecords] = useState(0);
 
//    const history = useHistory();
//    const isMounted = useRef(true);
 
//    // Fetch meals data with pagination
//    const fetchMealsData = async () => {
//      setLoading(true);
//      setApiError(null);
//      try {
//        const response = await fetch('https://navrang.mvd-tech.io/API/meal_data_load.php', {
//          method: 'POST',
//          headers: {
//            'Content-Type': 'application/json',
//             Accept: 'application/json',
//          },
//          body: JSON.stringify({
//            search: searchQuery,
//            limit: itemsPerPage,
//            offset: (currentPage - 1) * itemsPerPage,
//          }),
//        });
//        console.log((currentPage - 1) * itemsPerPage);
 
//        const mealsResponse = await response.json();
//        if (mealsResponse && Array.isArray(mealsResponse.data)) {
//          if (isMounted.current) {
//            setMealsData(mealsResponse.data);
//            setFilteredMealsData(mealsResponse.data);
//            setTotalRecords(mealsResponse.totalRecords);
//          }
//        } else if (isMounted.current) {
//            setMealsData([]);
//            setFilteredMealsData([]);
//          }
//      } catch (error) {
//        if (isMounted.current) {
//          setApiError('Error loading meals. Please try again later.');
//        }
//      } finally {
//        if (isMounted.current) {
//          setLoading(false);
//        }
//      }
//    };
 
//    // Trigger API call when page or search query changes
//    useEffect(() => {
//      isMounted.current = true;
//      fetchMealsData();
//      return () => {
//        isMounted.current = false;
//      };
//    }, [refresh, currentPage, searchQuery]);
 
//    const handleSearch = (e) => {
//      const query = e.target.value;
//      setSearchQuery(query);
//      setCurrentPage(1); // Reset to first page on search change
//    };
 
//    const refreshHandler = () => {
//      setRefresh(prev => !prev);
//      toast.success('Refreshing...');
//    };
 
//    const handlePageChange = (pageNumber) => {
//      setCurrentPage(pageNumber); // Update currentPage
//    };
 
//    // Slice the filtered data to display current page items
//    const indexOfLastItem = currentPage * itemsPerPage;
//    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//    const currentItems = filteredMealsData.slice(indexOfFirstItem, indexOfLastItem);
 
//    // Calculate total pages
//    const totalPages = Math.ceil(totalRecords / itemsPerPage);
 
//    // Generate page numbers
//    const pageNumbers = [];
//    const maxVisiblePages = 5;
//    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
 
//    if (endPage - startPage < maxVisiblePages - 1) {
//      startPage = Math.max(1, endPage - maxVisiblePages + 1);
//    }
 
//    for (let i = startPage; i <= endPage; i += 1) {
//      pageNumbers.push(i);
//    }
 
//    if (startPage > 1) pageNumbers.unshift('...');
//    if (endPage < totalPages) pageNumbers.push('...');
 
//    const handleCancelAddMeal = () => {
//      if (tripDataFlag.addMealINBooking) {
//        setTripDataFlag(prevState => ({
//          ...prevState,
//          tripID: '',
//          name: '',
//          addMealINBooking: false,
//        }));
//        toast.success('Add Meal Cancelled');
//      }
//      history.push('/admin/booking');
//    };
 
//    return (
//      <Container>
//        <Row>
//          <Col md={12} />
//        </Row>
 
//        <Row>
//          <div className="col-md-6 mb-4 d-flex align-items-center">
//            <Form.Control
//              type="text"
//              placeholder="Search by Meal Name..."
//              value={searchQuery}
//              onChange={handleSearch}
//              className="flex-grow-1"
//              style={{
//                backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
//                color: currentTheme === 'Dark' ? 'white' : 'black',
//              }}
//            />
//            <ButtonGroup icons dir="ltr" className="mt-2">
//              <Button variant="outline-secondary" className="ms-3" title="Refresh" size="sm" onClick={refreshHandler}>
//                <span className="lnr lnr-sync" />
//              </Button>
//            </ButtonGroup>
 
//            <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
//              <Button variant="outline-info" title="Filter">
//                <FaFilter />
//              </Button>
//            </ButtonGroup>
 
//            <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
//              {tripDataFlag.addMealINBooking && (
//                <Button variant="danger" title="Cancel Add Meal" size="sm" onClick={handleCancelAddMeal}>
//                  Cancel Add Meal
//                </Button>
//              )}
//            </ButtonGroup>
//          </div>
//        </Row>
 
//        <Row>
//          <div>
//            {/* Check for loading state */}
//            {loading && <p>Loading...</p>}
 
//            {/* Check for API error */}
//            {apiError && <p>{apiError}</p>}
 
//            {/* Check if no meals are found */}
//            {filteredMealsData.length === 0 && !loading && !apiError && <p>No meals found</p>}
 
//            {/* Display meals if no errors or loading */}
//            {!loading && !apiError && filteredMealsData.length > 0 && currentItems.map(meal => (
//              <div key={meal.id}>
//                <MealCard
//                  id={meal.id}
//                  mealname={meal.name}
//                  restaurantname={meal.restaurant_name}
//                  description={meal.description}
//                  type={meal.meal_type}
//                  capacity={meal.capacity}
//                  price={meal.price}
//                  finalprice={meal.final_price}
//                  format={meal.meal_format}
//                  image={meal.photo}
//                  isVeg={meal.veg_non_veg}
//                  mealOffereds={meal.meal_offered}
//                  cuisine={meal.cuisines}
//                  theme={currentTheme}
//                  locations={meal.locations}
//                />
//              </div>
//      ))}
//          </div>
//        </Row>
 
 
//        {/* Pagination Controls */}
//        <div
//          style={{
//            bottom: '20px',
//            right: '20px',
//            zIndex: 999,
//            display: 'flex',
//            justifyContent: 'flex-end',
//            alignItems: 'center',
//          }}
//        >
//          <Pagination>
//            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//            {pageNumbers.map(number => (
//              number === '...' ? (
//                <Pagination.Ellipsis key={number} />
//              ) : (
//                <Pagination.Item
//                  key={number}
//                  active={number === currentPage}
//                  onClick={() => handlePageChange(number)}
//                >
//                  {number}
//                </Pagination.Item>
//              )
//            ))}
//           <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//          </Pagination>
//        </div>
//      </Container>
//    );
//  };
 
//  export default Search;
 

// import React, { 
//   useState, 
//   useEffect, 
//   useContext, 
//   useRef, 
// } from 'react';
// import { 
//   Col, 
//   Container, 
//   Row, 
//   Form,
//  } from 'react-bootstrap';
// import { Button, ButtonGroup } from '@/shared/components/Button';
// import toast from 'react-hot-toast';
// import { useHistory } from 'react-router-dom';
// import Pagination from 'react-bootstrap/Pagination';
// import { FaFilter } from 'react-icons/fa';
// import MealCard from './MealCard';
// import { Mealcontext } from '../../../../context/MealContext';
// import { BookingContext } from '../../../../context/BookingContext';
// import { ThemeContext } from '../../../../context/ThemeContext';
// import ProgressBar from '../../Loader';



// const Search = () => {
//   const { refresh, setRefresh } = useContext(Mealcontext);
//   const { currentTheme } = useContext(ThemeContext);
//   const { tripDataFlag, setTripDataFlag } = useContext(BookingContext);
//   const [searchQuery, setSearchQuery] = useState(''); 
//   const [mealsdata, setMealsData] = useState([]);
//   const [filteredMealsData, setFilteredMealsData] = useState([]);
//   const [isLoading, setIsloading] = useState(true);
//   const [mounted, setMounted] = useState(false);

//   // Pagination state
//       const [currentPage, setCurrentPage] = useState(1);
//       const itemsPerPage = 7;
    
//       // Handle page change
//       const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//       };
    
      

//   const history = useHistory();

//   const isMounted = useRef(true);

//   const fetchMealsData = async () => {
//     setIsloading(true);
//     try {
//       const response = await fetch('https://navrang.mvd-tech.io/API/meal_data_new.php');
//       const mealsResponse = await response.json();

//       if (mealsResponse && Array.isArray(mealsResponse.data)) {
//         console.log('Loaded successfully');
//         if (isMounted.current) {
//           setMealsData(mealsResponse.data);
//           setFilteredMealsData(mealsResponse.data);
//           console.log(mealsResponse.data);
//         }
//       } else {
//         console.log('No data found');
//         if (isMounted.current) {
//           setMealsData([]);
//           setFilteredMealsData([]);
//         }
//       }
//     } catch (error) {
//       console.error('Error loading meals', error);
//     } finally {
//       setIsloading(false);
//     }
//   };

//   useEffect(() => {
//     isMounted.current = true;
//     fetchMealsData();
//     return () => {
//       isMounted.current = false;
//     };
//   }, [refresh]); 


//   const handleSearch = (e) => {
//     const query = e.target.value;
//     setSearchQuery(query);

//     if (query) {
//       const filteredData = mealsdata.filter(meal => meal.name.toLowerCase().includes(query.toLowerCase()));
//       setFilteredMealsData(filteredData); 
//     } else {
//       setFilteredMealsData(mealsdata); 
//     }
//   };

//   // Refresh handler
//   const refreshHandler = () => {
//       // fetchMealsData(); 
//       setRefresh(prev => !prev);
//       toast.success('Refreshing...');
//   };

//   // Pagination Logic - Slice data for the current page
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;

//   // Use filteragent for pagination, not agent
//   const currentItems = filteredMealsData.slice(indexOfFirstItem, indexOfLastItem);

//   // Total pages should be based on filteragent length, not agent
//   const totalPages = Math.ceil(filteredMealsData.length / itemsPerPage);

//  // Generate a range of pagination items, including "..."
// const pageNumbers = [];
// const maxVisiblePages = 3; // This will display only 3 page numbers (e.g., 1, 2, 3 or 2, 3, 4)
// const startPage = Math.max(1, currentPage - 1); // Allow for 1 page before
// const endPage = Math.min(totalPages, currentPage + 1); // Allow for 1 page after

// // Add the page numbers in the range of startPage to endPage
// for (let i = startPage; i <= endPage; i += 1) {
//   pageNumbers.push(i);
// }

// // If the first page is greater than 1, add '...'
// if (startPage > 1) {
//   pageNumbers.unshift('...');
// }

// // If the last page is less than the total pages, add '...'
// if (endPage < totalPages) {
//   pageNumbers.push('...');
// }

// // Add the last page number if it's not already in the array
// if (pageNumbers[pageNumbers.length - 1] !== totalPages) {
//   pageNumbers.push(totalPages);
// }



//   const handleCancelAddMeal = () => {
//     // Only reset addMealINBooking if it's true
//     if (tripDataFlag.addMealINBooking) {
//       setTripDataFlag(prevState => ({
//         ...prevState,
//         tripID: '',
//         name: '',
//         addMealINBooking: false,
//       }));
//       toast.success('Add Meal Cancel');
//     }
  
//     // Navigate to /admin/booking
//     history.push('/admin/booking');
//   };


  
//     if (isLoading) {
//       return (
//         <div
//           style={{
//             display: 'flex',
//             // justifyContent: 'center', // Center horizontally
//             // alignItems: 'center', // Center vertically
//             height: '100vh', // Full viewport height
//           }}
//         >
//           <ProgressBar />
//         </div>
//       );
//     }
  
  


  

//   return (
//     <Container>
//       <Row>
//         <Col md={12} />
//       </Row>

//       <Row>
//         <div className="col-md-6 mb-4 d-flex align-items-center">
//           <Form.Control
//             type="text"
//             placeholder="Search by Meal Name..."
//             value={searchQuery}
//             onChange={handleSearch}
//             className="flex-grow-1"
//             style={{
//               backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
//               color: currentTheme === 'Dark' ? 'white' : 'black',
//             }}
//           />
//           <ButtonGroup icons dir="ltr" className="mt-2">
//             <Button
//               variant="outline-secondary"
//               className="ms-3"
//               title="Refresh"
//               size="sm"
//               onClick={refreshHandler}
//             >
//               <span className="lnr lnr-sync" />
//             </Button>
//           </ButtonGroup>

//           <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
//             <Button 
//               variant="outline-info"
//               title="Filter" 
//             >
//               <FaFilter />
//             </Button>
//           </ButtonGroup>
//           <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
//             {tripDataFlag.addMealINBooking === true
//             && (
//             <Button 
//               variant="danger"
//               title="Cancel Add Meal"
//               size="sm"
//               onClick={() => handleCancelAddMeal()}
//             >
//               Cancel Add Meal
//             </Button>
// )}
            
//           </ButtonGroup>
//         </div>
//       </Row>

//       <Row>
//         <div>
//           {filteredMealsData.length === 0 ? (
//             <p>No meals found</p>
//           ) : (
//             currentItems.map(meal => (
//               <div key={meal.id}>
//                 <MealCard
//                   id={meal.id}
//                   mealname={meal.name}
//                   restaurantname={meal.restaurant_name}
//                   description={meal.description}
//                   type={meal.meal_type}
//                   capacity={meal.capacity}
//                   price={meal.price}
//                   finalprice={meal.final_price}
//                   format={meal.meal_format}
//                   image={meal.photo}
//                   isVeg={meal.veg_non_veg}
//                   mealOffereds={meal.meal_offered}
//                   cuisine={meal.cuisines}
//                   theme={currentTheme}
//                   locations={meal.locations}
//                 />
//               </div>
//             ))
//           )}
//         </div>
//       </Row>
//       <div
//         style={{
//     bottom: '20px',
//     right: '20px',
//     zIndex: 999,
//     display: 'flex',
//     justifyContent: 'flex-end',
//     alignItems: 'center',
//   }}
//       >
//         <Pagination>
//           <Pagination.Prev
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//           />
//           {pageNumbers.map((number, index) => (number === '...' ? (
//             <Pagination.Ellipsis key={number} />
//       ) : (
//         <Pagination.Item
//           key={number}
//           active={number === currentPage}
//           onClick={() => handlePageChange(number)}
//         >
//           {number}
//         </Pagination.Item>
//       )))}
//           <Pagination.Next
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//           />
//         </Pagination>
//       </div>

//     </Container>
//   );
// };

// export default Search;
